import {Directive, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {Store} from '@ngxs/store';
import { distinctUntilChanged } from 'rxjs/operators';
import { NUMBER_MIN_VALUE } from 'src/app/shared/constants/constants';
import {collectErrors} from 'src/app/shared/helpers/helpers';

@UntilDestroy()
@Directive()
export class DrugProcessingBaseDirective {
  _drug: {drugID: '', friendlyName: '', packageNdc: '', onHand: 0};
  get drug() {
    return this._drug;
  }

  @Input() set drug (value) {
    this._drug = value;
    this.dialogForm.get('friendlyName').setValue(value?.friendlyName);
    this.optionSelected(value);
    this.currentOption = {...this.currentOption, onHand: value?.onHand};
  }

  @Input() set maxQty (value) {
    const addedQtyControl = this.dialogForm.controls.addedQuantity;
    addedQtyControl.setValidators([
      Validators.required,
      Validators.min(NUMBER_MIN_VALUE),
      Validators.max(value),
    ]);
    
    addedQtyControl.updateValueAndValidity();
  }

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() addedQtyValueChanged: EventEmitter<number> = new EventEmitter();
  @Output() validateForm: EventEmitter<void> = new EventEmitter();

  currentOption: any;

  dialogForm: UntypedFormGroup;

  constructor(
    public store: Store,
    private _fb: UntypedFormBuilder,
  ) {
    this.dialogForm = this._fb.group({
      drugId: ['', [Validators.required]],
      friendlyName: ['', [Validators.required]],
      rxNumber: ['', []],
      patientName: ['', []],
      addedQuantity: ['', [Validators.required]],
      description: ['', []],
    });

    this.dialogForm?.get('addedQuantity')?.valueChanges
    .pipe(distinctUntilChanged(), untilDestroyed(this))
    .subscribe(val => this.addedQtyValueChanged.emit(val));
  }

  public get formErrors(): any | null {
    const errors = collectErrors(this.dialogForm);
    return JSON.stringify(errors);
  }

  handleSearchInput(value: string): void {
    if (this.currentOption && !value) {
      this.currentOption = null;
      this.dialogForm.reset();
      this.dialogForm.get('drugId').patchValue('');
    }
  }

  optionSelected(option: any): void {
    this.currentOption = option;
    if (option) {
      this.dialogForm.get('drugId').patchValue(option.drugID ?? option.id);
      this.dialogForm.get('addedQuantity').setValidators([
        Validators.required,
        Validators.min(NUMBER_MIN_VALUE),
        Validators.max(option && option.onHand),
      ]);
    } else {
      this.dialogForm.get('drugId').patchValue(null);
    }
  }

  sendTransaction(): void {
    if (this.dialogForm.valid) {
      this.save.emit(this.dialogForm.getRawValue());
      this.dialogForm.reset();
    }
  }

  close(): void {
    this.dialogForm.reset();
    this.cancel.emit();
  }
}
